var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgSeguros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "83px",
    viewBox: "0 0 71 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_seguros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2885.000000, -435.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_seguros",
    transform: "translate(2887.929713, 438.574076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92458301,8.00989656 C3.56416643,9.64031325 0,14.7969788 0,19.4228123 L0,47.594895 C0,52.0690614 2.95749921,57.9461435 6.5595825,60.6382267 L22.863749,72.8094841 C28.2099989,76.8286505 37.0066671,76.8286505 42.352917,72.8094841 L58.6570807,60.6382267 C62.259164,57.9461435 65.2166696,52.0690614 65.2166696,47.594895 L65.2166696,19.4228123 C65.2166696,14.7590622 61.6525022,9.60239572 57.2920856,7.97197902 L38.3716662,0.881562507 C35.1487495,-0.293854169 29.992083,-0.293854169 26.8449997,0.881562507 L7.92458301,8.00989656 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3850555,37.4332091 L27.4896376,43.5377911 L43.793805,27.2336273",
    id: "Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSeguros);
export default __webpack_public_path__ + "static/media/svg_seguros.fa592a9d990652d0f39427f2cb91068f.svg";
export { ForwardRef as ReactComponent };